import { render, staticRenderFns } from "./DeliveryListDispatchedPage.vue?vue&type=template&id=74e7a3fc&scoped=true&"
import script from "./DeliveryListDispatchedPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryListDispatchedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e7a3fc",
  null
  
)

export default component.exports